import React, { useEffect, useMemo, useState } from 'react';
import { Slider } from '@mui/material';
import CustomSliderThumb from './shared/thumb';

const CustomSlider = ({
  value: extValue,
  setValue: setExtValue,
  minDistance = 1,
  minValue = 0,
  maxValue = 100,
  double = false,
  markPointsEvery = null,
  step = 1,
  className = undefined,
  onFocus = () => {},
  onBlur = () => {},
  id = undefined,
  name = undefined,
}) => {
  const defaultValue = double ? [minValue, maxValue] : minValue;
  const [value, setValue] = useState(extValue || defaultValue);

  useEffect(() => {
    if (extValue !== value) setValue(extValue);
  }, [extValue]);

  const marksPoints = useMemo(() => {
    if (minValue >= maxValue || !markPointsEvery || markPointsEvery <= 0) return [];

    if (maxValue - minValue > markPointsEvery) {
      const result = [minValue];
      for (let i = minValue; i < maxValue; i++) {
        if (i % markPointsEvery === 0 && i - minValue > 5 && maxValue - i > 5) result.push(i);
      }
      result.push(maxValue);
      return result;
    }
    return [minValue, maxValue];
  }, [minValue, maxValue, markPointsEvery]);

  const handleChange = (event, newValue, activeThumb) => {
    if (double) {
      if (Array.isArray(newValue)) {
        let changed;
        if (activeThumb === 0) {
          changed = [Math.min(newValue[0], value[1] - minDistance), value[1]];
        } else {
          changed = [value[0], Math.max(newValue[1], value[0] + minDistance)];
        }
        if (setExtValue) setExtValue(changed);
        else setValue(changed);
      }
    } else {
      if (!isNaN(newValue)) {
        if (setExtValue) setExtValue(newValue);
        else setValue(newValue);
      }
    }
  };

  return (
    <Slider
      value={value}
      onChange={(e, newValue, activeThumb) => handleChange(e, newValue, activeThumb)}
      getAriaValueText={(t) => String(t)}
      valueLabelDisplay="auto"
      disableSwap
      components={{ Thumb: CustomSliderThumb }}
      min={minValue}
      max={maxValue}
      marks={marksPoints.map((point) => ({ value: point, label: point }))}
      step={step}
      className={className}
      onFocus={onFocus}
      onBlur={onBlur}
      id={id}
      name={name}
    />
  );
};

export default CustomSlider;
